import React, { useRef, useState, useEffect } from 'react';
import { Alert, Button, Col, Form, Modal, Table } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import Loader from 'react-loader-spinner';
import { Accordion, Card } from 'react-bootstrap';
import QRCodeReader from "../QRCode_Reader/QR_Reader";
import { resetProductQRCode } from "../../store/api/GetAllProduct";
import { getActiveUnusedGuaranteeCards } from "../../store/api/GuaranteeApi";
import { getSerialHistory, setSerialHistoryPopup } from "../../store/api/Services";
import barCodeImg from "../../content/images/barcodeReader.png";
import { convertChar, toEnglishNumber } from '../../store/api/ConvertToEnglish';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { ExclamationTriangle } from 'react-bootstrap-icons';
import { isWebApp, useIsMobileApp } from '../../../store/api/CommonFunctions';
import BihamtaTable from '../../../Components/BihamtaTable';


const ModalSerialHistory = (props) => {

    const serialHistoryPopup = useSelector(state => state.service?.serialHistoryPopup);
    const { serialHistory } = useSelector(state => { return { serialHistory: state.service.serialHistory } });
    const activeUnusedCards = useSelector(state => state.guaranteeCardsReducer.activeUnusedCards);
    const [qrCodePop, setqrCodePop] = useState({ show: false });
    const [error, setError] = useState(null);
    const searchData = useRef({});
    const searchCardData = useRef({});
    const dispatch = useDispatch();
    const isMobile = useIsMobileApp();
    const [width, setWidth] = useState(window.innerWidth);
    const tableCols = [
        { colName: "RowNumber", colTitle: "ردیف", showInMobile: true },
        { colName: "POperatorType", colTitle: "نام فرم", showInMobile: true },
        { colName: "PHistoryDate", colTitle: "تاریخ فرم", showInMobile: true },
        { colName: "OperatorNumber", colTitle: "شماره فرم", showInMobile: true },
        { colName: "ProductName", colTitle: "نام محصول" },
        { colName: "ProductModel", colTitle: "مدل محصول" },
        { colName: "SerialNumber", colTitle: "سریال محصول" },
    ]    
    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }
    useEffect(() => {
        dispatch(resetProductQRCode());
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);
    const handleModal = () => {
        dispatch(setSerialHistoryPopup({ status: 'hide' }));
    }
    const onChangeSearchData = (value, type) => {
        if (type === "G_CardNo") {
            searchCardData.current.CardNo = value;
        }
        else if (type === "G_Serial") {
            searchCardData.current.Serial = value;
        }
        else if (type === "SH_CardNo") {
            searchData.current.CardNo = value;
        }
        else if (type === "SH_Serial") {
            searchData.current.Serial = value;
        }
    }
    const onScanQrCode = (type, value) => {
        document.getElementById(type).value = value;
        onChangeSearchData(value, type);
    }
    const searchHistory = () => {

        if ((searchData.current.CardNo ?? "") === '' && (searchData.current.Serial ?? "") === '') {
            setError('هیچکدام از کادرهای جستجو پر نشده است');
            setTimeout(()=>{
                setError(null);
            },1000)
            return;
        }
        dispatch(getSerialHistory(searchData.current.Serial, searchData.current.CardNo, -1, -1));
    }
    const searchUnusedCards = () => {

        if ((searchCardData.current.CardNo ?? "") === '' && (searchCardData.current.Serial ?? "") === '') {
            setError('هیچکدام از کادرهای جستجو پر نشده است');
            setTimeout(()=>{
                setError(null);
            },1000)            
            return;
        }
        dispatch(getActiveUnusedGuaranteeCards(searchCardData.current.CardNo, searchCardData.current.Serial, 0, 10));
    }
    const select = (item) => {
        if (serialHistoryPopup.onSetData) {
            if (item.RelatedProductID) {
                item.ProductID = item.RelatedProductID;
            }
            if (item.RelatedProductModel) {
                item.ProductModel = item.RelatedProductModel;
            }
            if (item.RelatedProductName) {
                item.ProductName = item.RelatedProductName;
            }
            serialHistoryPopup.onSetData(item);
        }
        dispatch(setSerialHistoryPopup({ status: 'hide' }));
    }
    function showPopQrCode(type) {
        setqrCodePop({
            show: true,
            onScan: (value) => onScanQrCode(type, value)
        })
    }
    return (
        <Modal size="lg" show={serialHistoryPopup.status === 'show'} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header className='headerStyle'>تاریخچه سریال/گارانتی<FontAwesomeIcon icon={faTimes} size='lg' onClick={handleModal} /></Modal.Header>
            <Modal.Body className='bodyStyle'>
                <QRCodeReader popData={qrCodePop} setPopData={setqrCodePop} />
                {error &&
                    <Alert variant='danger'>
                        <span>
                            <ExclamationTriangle size={18} />&nbsp;
                            {error}
                            <FontAwesomeIcon icon={faTimes} size='lg' onClick={() => setError(null)} style={{ float: "left" }} />
                        </span>
                    </Alert>
                }
                <Accordion defaultActiveKey="1">
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="1" style={{ backgroundColor: "rgb(30 165 187)" }}>
                            جستجوی کارت گارانتی خام
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="1">
                            <Card.Body>
                                <div className="row">
                                    <Col md={6} className="form-group">
                                        <Form.Control placeholder="شماره گارانتی" lang='en' id="G_CardNo" onChange={(e) => onChangeSearchData(e.target.value, "G_CardNo")} style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }} />
                                        <Button variant='outline-danger' className="btn-input-tiny" onClick={() => showPopQrCode("G_CardNo")} style={{ top: 6, left: 12 }}>
                                            <img src={barCodeImg} alt="" style={{ height: "26px" }} />
                                        </Button>
                                    </Col>
                                    <Col md={6} className='form-group'>
                                        <Form.Control placeholder="شماره سریال" lang='en' id="G_Serial" onChange={(e) => onChangeSearchData(e.target.value, "G_Serial")} style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }} />
                                        <Button variant='outline-danger' className="btn-input-tiny" onClick={() => showPopQrCode("G_Serial")} style={{ top: 6, left: 12 }}>
                                            <img src={barCodeImg} alt="" style={{ height: "26px" }} />
                                        </Button>
                                    </Col>
                                </div>
                                <button type="button" className="btn btn-primary w-100 mt-2" onClick={searchUnusedCards}>جستجو</button>
                                <br />
                                <br />
                                {activeUnusedCards === "PENDING" &&
                                    <Loader style={{ textAlign: "center" }} type="BallTriangle" color="#bb1370" height={25} width={25} />
                                }
                                {Array.isArray(activeUnusedCards) &&
                                    <div style={{overflow:"auto"}}>
                                        <Table style={{ whiteSpace:"nowrap" }}>
                                            <thead>
                                                <tr style={{ padding: "0" }}>
                                                    {!isMobile &&
                                                        <><th>برند</th>
                                                            <th>شماره کارت</th>
                                                            <th>شماره سریال</th>
                                                        </>
                                                    }
                                                    <th>{width > 414 ? "نام و مدل محصول" : "محصول"}</th>
                                                    <th>آغاز گارانتی</th>
                                                    <th>پایان گارانتی</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {activeUnusedCards.map((item, i) => {
                                                    return (
                                                        <tr className='resultTableRow' key={i} style={{ backgroundColor: i % 2 === 0 ? "white" : "#e9e9e9" }} onClick={() => select(item)}>
                                                            {!isMobile && <>
                                                                <td>{item?.HolderName}</td>
                                                                <td>{item?.GuaranteeCardNo}</td>
                                                                <td>{item?.SerialNumber}</td>
                                                            </>}
                                                            <td>{item?.RelatedProductName}-{item?.RelatedProductModel}</td>
                                                            <td>{item?.GuaranteeStartPersianDate}</td>
                                                            <td>{item?.GuaranteePersianEndDate}</td>
                                                        </tr>)
                                                })
                                                }
                                            </tbody>
                                        </Table>
                                    </div>}
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                    <Card className='mt-1'>
                        <Accordion.Toggle as={Card.Header} eventKey="0" style={{ backgroundColor: "#d88463" }}>
                            تاریخچه سریال
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="0">
                            <Card.Body>
                                <div className="row">
                                    <Col md={6} className="form-group">
                                        <Form.Control placeholder="شماره گارانتی" lang='en' id="SH_CardNo" onChange={(e) => onChangeSearchData(e.target.value, "SH_CardNo")} style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }} />
                                        <Button variant='outline-danger' className="btn-input-tiny" onClick={() => showPopQrCode("SH_CardNo")} style={{ top: 6, left: 12 }}>
                                            <img src={barCodeImg} alt="" style={{ height: "26px" }} />
                                        </Button>
                                    </Col>
                                    <Col md={6} className='form-group'>
                                        <Form.Control placeholder="شماره سریال" lang='en' id="SH_Serial" onKeyUp={(e) => toEnglishNumber(e)} onChange={(e) => onChangeSearchData(e.target.value, "SH_Serial")} style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }} />
                                        <Button variant='outline-danger' className="btn-input-tiny" onClick={() => showPopQrCode("SH_Serial")} style={{ top: 6, left: 12 }}>
                                            <img src={barCodeImg} alt="" style={{ height: "26px" }} />
                                        </Button>
                                    </Col>
                                </div>
                                <button type="button" className="btn btn-primary w-100 mt-2" onClick={searchHistory}>جستجو</button>
                                <br />
                                <br />
                                {serialHistory === "PENDING" &&
                                    <Loader style={{ textAlign: "center" }} type="BallTriangle" color="#bb1370" height={25} width={25} />
                                }
                                    <BihamtaTable columns={tableCols} dataList={{Data:serialHistory}} maxHeight={350} rowClick={select} />
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
            </Modal.Body>
        </Modal >
    )
}
export default ModalSerialHistory;